
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.708 5.695a1 1 0 01-1.413 0L5.006 2.41 1.717 5.695a1 1 0 11-1.412-1.41L4.3.291a1 1 0 011.412 0l3.996 3.992a.998.998 0 010 1.411z","fill":"#fff"}})])
          )
        }
      }
    